import * as React from 'react';

import * as styles from './publish_vacancy_ban.css';
import { LinkButton } from '@cian/ui-kit';

const PublishVacancyBan = () => (
  <div className={styles['panel']}>
    <div className={styles['head']}>
      <div className={styles['text']}>К сожалению, вам недоступна публикация вакансий</div>
      <div className={styles['text_sup']}>
        Возможно, к вашему аккаунту применены санкции или не подключен тариф Базовый или Профи
      </div>
    </div>
    <div className={styles['links']}>
      <LinkButton size="XS" theme="stroke_primary" href="https://www.cian.ru/price/">
        Тарифы
      </LinkButton>
      <span className={styles['point']} />
      <LinkButton size="XS" theme="stroke_primary" href="https://my.cian.ru/">
        Личный кабинет
      </LinkButton>
      <span className={styles['point']} />
      <LinkButton size="XS" theme="stroke_primary" href="/vacancies">
        Поиск вакансий
      </LinkButton>
    </div>
  </div>
);

export { PublishVacancyBan };
